export default "__VITE_ASSET__BXoOt7qL__"